import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("token") || "",
  userId: localStorage.getItem("userId") || "",
};
const userAuthSlice = createSlice({
  name: "userAuth",
  initialState,
  reducers: {
    updateAccessToken(state, action) {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem("token", action.payload.token);
      }
      if (action.payload.userId) {
        localStorage.setItem("userId", action.payload.userId);
      }
    },
    clearAccessToken(state) {
      state.token = "";
      state.userId = "";
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
    }
  },
});

export const { updateAccessToken,clearAccessToken } = userAuthSlice.actions;
export const userAuthReducer = userAuthSlice.reducer;
export default userAuthSlice;
